import React from 'react'
import { Button } from "react-bootstrap"
import Col from "react-bootstrap/Col"

const ButtonField = ({type, name, value, fieldClass, grpmd, customClass, iconElement, handlClick}) => (
	<div className={`${customClass}`}>
		{
			type === "button" ? 
			<Button variant="" type={type} className={fieldClass} onClick={()=>handlClick(false)}> 
				{value && <span>{value}</span>}
				{iconElement ? iconElement : ""}
			</Button>
			:
			<Button variant="" type={type} className={fieldClass}> 
				{value && <span>{value}</span>}
				{iconElement ? iconElement : ""}
			</Button>
		}
		
	</div>
);

export default ButtonField;